import React from 'react';
import HeaderNavView from './HeaderNav-view';

const HeaderNav = () => {
  return <HeaderNavView/>;
};

HeaderNav.propTypes = {};

export default HeaderNav;
